import { useState } from 'react';
import { useAtom } from 'jotai';
import { useToast } from '@chakra-ui/react';
import { KeyRound } from 'lucide-react';
import { ConfirmSheet } from './ConfirmSheet';
import { offerPasskeyHereAtom } from '../store';
import { useT } from '../i18n';
import {
  addPasskeyHere,
  deviceErrorMessage,
  guessDeviceName,
} from '../lib/devices';

// After signing in with a phone's passkey on a computer, offer a passkey on
// the computer itself, so next time it doesn't need the phone (M41, D93).
export function PasskeyHereOffer() {
  const [isOpen, setOpen] = useAtom(offerPasskeyHereAtom);
  const [saving, setSaving] = useState(false);
  const toast = useToast();
  const t = useT();

  const create = async () => {
    setSaving(true);
    try {
      await addPasskeyHere(guessDeviceName());
      setOpen(false);
      toast({
        title: t('account.passkeyHere.done'),
        status: 'success',
      });
    } catch (err) {
      const message = deviceErrorMessage(err);
      if (message) {
        toast({
          title: t('account.passkeyHere.failed'),
          description: message,
          status: 'error',
        });
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <ConfirmSheet
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      icon={<KeyRound size={28} />}
      centered
      title={t('account.passkeyHere.title')}
      body={t('account.passkeyHere.body')}
      confirmLabel={t('account.passkeyHere.create')}
      cancelLabel={t('account.passkeyHere.notNow')}
      isLoading={saving}
      onConfirm={() => void create()}
    />
  );
}
